import { lazy } from "react";
import { Navigate } from "react-router-dom";
import CourseRegistration from "../components/course-registration/course-registration";
import ErrorPage from "../components/error/errorPage";
import Home from "../components/home/home";
import RouterGuard from "../components/shared/route-guard/route-guard";
import ProctorRoute from "../routes/proctors.route";
import Root from "../routes/root";
import SecondaryLayout from "../routes/secondaryLayout";
import Reports from "../components/reports/reports";
import Settings from "../components/profile-settings/settings";
import StaffGuides from "../components/staff-guides/staff-guides";

const Dashboard = lazy(() => import("../components/dashboard/dashboard"));
const CoursesRoute = lazy(() => import("../routes/courses.route"));
const CourseDetailRoute = lazy(() => import("../routes/course-detail.route"));
const StudentsRoute = lazy(() => import("../routes/students.route"));
const AllTeamMembersRoute = lazy(
  () => import("../routes/all-team-members.route"),
);
const Login = lazy(() => import("../components/login/login"));
const ValidateUser = lazy(
  () => import("../components/validate-user/validate-user"),
);
const SignUp = lazy(() => import("../components/signup/signUp"));
const ResetPassword = lazy(
  () => import("../components/reset-password/reset-password"),
);
export const PublicRoutes = () => {
  return [
    {
      path: "/",
      element: <Root />,
      errorElement: <ErrorPage />,
      children: [
        { path: "/", element: <Navigate to="/SEABC" /> },
        { path: ":acronym", element: <Home /> },
        {
          path: ":acronym/dashboard",
          element: (
            <RouterGuard>
              <Dashboard />
            </RouterGuard>
          ),
        },
        {
          path: ":acronym/guides",
          element: (
            <RouterGuard>
              <StaffGuides />
            </RouterGuard>
          ),
        },
        { path: ":acronym/courses", element: <CoursesRoute listType="all" /> },
        {
          path: ":acronym/reports",
          element: (
            <RouterGuard>
              <Reports />
            </RouterGuard>
          ),
        },
        {
          path: ":acronym/settings",
          element: (
            <RouterGuard>
              <Settings />
            </RouterGuard>
          ),
        },
        {
          path: ":acronym/settings/:id",
          element: (
            <RouterGuard>
              <Settings />
            </RouterGuard>
          ),
        },
        {
          path: ":acronym/my-courses",
          element: <CoursesRoute listType="my" />,
        },
        {
          path: ":acronym/my-courses/:id",
          element: <CoursesRoute listType="my" />,
        },
        {
          path: "/:acronym/proctor",
          element: (
            <RouterGuard allowProctor={true}>
              <ProctorRoute />
            </RouterGuard>
          ),
        },
        {
          path: ":acronym/courses/:id",
          element: <CourseDetailRoute />,
        },
        {
          path: "/:acronym/institutions/:id/students",
          element: (
            <RouterGuard>
              <StudentsRoute />
            </RouterGuard>
          ),
        },
        {
          path: "/:acronym/courses/:id/registration",
          element: (
            <RouterGuard>
              <CourseRegistration />
            </RouterGuard>
          ),
        },
        { path: ":acronym/students", element: <StudentsRoute /> },
        { path: ":acronym/team-members", element: <AllTeamMembersRoute /> },
      ],
    },
    {
      path: "/",
      element: <SecondaryLayout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: ":acronym/restore-password/:token",
          element: <ResetPassword />,
        },
        { path: "user-confirmation/:id", element: <ValidateUser /> },
        { path: ":acronym/login", element: <Login /> },
        { path: ":acronym/signup", element: <SignUp /> },
      ],
    },
  ];
};
